/* eslint-disable no-unused-vars */
import { Directive, Injector, Input, OnChanges, OnDestroy, Optional, SimpleChanges } from '@angular/core';
import { Farris, FrameContext, ViewRuleRegistry } from '@farris/devkit';
const EXCLUDE_VALIDATE_FIELDS = 'excludeValidateRules';
const RULETYPE = 'required';
@Directive({
  selector: '[farris-dynamic-required]'
})
export class FarrisDynamicRequiredDirective implements OnChanges, OnDestroy {
  /**
   * like {field:'',type:'require'}
   */
  @Input('farris-dynamic-required') field: string;
  /**
   * å¯ç¨æ ¡éªçæ¶æº
   */
  @Input('requiredOn') requiredOn: boolean = false;
  constructor(protected frameContext: FrameContext, private injector: Injector, @Optional() private viewRuleRegistry: ViewRuleRegistry) {

  }
  ngOnDestroy(): void {
    this.updateValidateRule(false);
  }
  ngOnChanges(changes: SimpleChanges): void {
    // å¯ç¨å¿å¡«æ ¡éª
    this.updateValidateRule(this.requiredOn);
  }
  /**
   *
   * @param isRequired
   */
  private updateValidateRule(isRequired: boolean) {
    if (!this.field) {
      return;
    }
    if (this.viewRuleRegistry) {
      const ngFormControl = this.frameContext.form.ngFormControls[this.field];
      if (ngFormControl) {
        const binding = ngFormControl.binding.split('.');
        const bindingPaths = this.frameContext.viewModel.bindingPath.split('/').filter((p) => p);
        const path = bindingPaths.concat(binding).join('.');
        const rule = this.viewRuleRegistry.getRuleById(path) as Farris.ViewRule.IFieldViewRule;
        // ç±çé¢è§åå¤çï¼å¨æå¿å¡«æ éå³å¿
        if (rule && (rule.required || !rule.visibility)) {
          return;
        }
      }
    }
    this.frameContext.form.updateFieldValidateRule(this.field, isRequired);
    // if (isRequired) {
    //   const rules = this.frameContext.params.get(EXCLUDE_VALIDATE_FIELDS) || {};
    //   const fieldExcludeRules: string[] = rules[this.field] || [];
    //   if (fieldExcludeRules.includes(RULETYPE)) {
    //     const index = fieldExcludeRules.indexOf(RULETYPE);
    //     fieldExcludeRules.splice(index, 1);
    //   }
    //   this.frameContext.params.set(EXCLUDE_VALIDATE_FIELDS, rules);
    //   this.frameContext.form.updateFieldValidateRule(this.field, fieldExcludeRules);
    // } else {
    //   // ç¦ç¨æ ¡éª
    //   // {int1:[required,maxValue]}
    //   const rules = this.frameContext.params.get(EXCLUDE_VALIDATE_FIELDS) || {};
    //   const fieldExcludeRules = rules[this.field] || [];
    //   if (fieldExcludeRules && !fieldExcludeRules.includes(RULETYPE)) {
    //     fieldExcludeRules.push(RULETYPE);
    //   }
    //   rules[this.field] = fieldExcludeRules;
    //   this.frameContext.params.set(EXCLUDE_VALIDATE_FIELDS, rules);
    //   this.frameContext.form.updateFieldValidateRule(this.field, fieldExcludeRules);
    // }
  }
}
